/**
 * 数据请求的唯一入口
 */
import home from './modules/home.js';

export default {
	home
}
